/**
 * Awards Prize block: the cards' shine and the live state switch.
 *
 * Markup: template-parts/awards/blocks/prize/{year}.php.
 *
 * Shine: plays when at least half of the banner is in view while scrolling
 * down (or on load) and resets once the banner is out of view, so the next
 * pass down plays it again; scrolling back up to it doesn't. Reduced motion is
 * handled in CSS.
 *
 * State: the page is cached, so when a countdown on the page passes voting
 * start (data-start) the button gets the open label, and when it passes the
 * deadline (data-end) heading and intro switch to the closed texts
 * (data-closed) and the button goes, as on the server after the deadline.
 */

import { END_EVENT } from './countdown';

const SHINE = 'awards-prize--shine';

function initShine(root) {
  const banner = root.querySelector('[data-prize-banner]');
  let lastY = window.scrollY;
  let down = true;

  window.addEventListener(
    'scroll',
    () => {
      down = window.scrollY > lastY;
      lastY = window.scrollY;
    },
    { passive: true }
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          root.classList.remove(SHINE);
        } else if (entry.intersectionRatio >= 0.5 && down) {
          root.classList.add(SHINE);
        }
      });
    },
    { threshold: [0, 0.5] }
  );

  observer.observe(banner);
}

function initState(root) {
  const start = Date.parse(root.dataset.start);
  const end = Date.parse(root.dataset.end);
  const cta = root.querySelector('[data-prize-cta]');

  document.addEventListener(END_EVENT, (event) => {
    if (event.detail.end === start && cta) {
      cta.textContent = root.dataset.openLabel;
    }

    if (event.detail.end === end) {
      const closed = JSON.parse(root.dataset.closed);
      const intro = root.querySelector('[data-prize-intro]');

      root.querySelector('[data-prize-title]').textContent = closed.heading;
      intro.textContent = closed.intro;
      intro.hidden = false;

      if (cta) {
        cta.remove();
      }
    }
  });
}

export default function initPrize(root) {
  initShine(root);
  initState(root);
}
